import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import { registerables } from 'chart.js';

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import zoomPlugin from 'chartjs-plugin-zoom';

import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import { getRelativePosition } from 'chart.js/helpers';

import { Observable, interval, map, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { GurdServiceService } from "src/app/Service/gurd-service.service";

declare let $: any;

@Component({

  selector: 'app-emdadran-dashbord',

  templateUrl: './emdadran-dashbord.component.html',

  styleUrls: ['./emdadran-dashbord.component.css']

})

export class EmdadranDashbordComponent implements OnInit {

  ctx1: any;

  obj1: any;

  label1: Array<any> = [];

  datachart1: Array<any> = [];

  obj2: any;

  label2: Array<any> = [];

  datachart2: Array<any> = [];

  ctx12: any;

  obj3: any;

  label3: Array<any> = [];

  datachart3: Array<any> = [];

  ctx13: any;

  obj4: any;

  label4: Array<any> = [];

  datachart4: Array<any> = [];

  ctx4: any;

  obj5: any;

  label5: Array<any> = [];

  datachart5: Array<any> = [];

  ctx15: any;

  obj6: any;

  label6: Array<any> = [];

  datachart6: Array<any> = [];

  ctx16: any;

  obj7: any;

  label7: Array<any> = [];

  datachart7: Array<any> = [];

  ctx17: any;

  obj8: any;

  label8: Array<any> = [];

  datachart8: Array<any> = [];

  ctx18: any;

  obj9: any;

  label9: Array<any> = [];

  datachart9: Array<any> = [];

  ctx19: any;

  obj10: any;

  label10: Array<any> = [];

  datachart10: Array<any> = [];

  ctx110: any;

  obj11: any;

  label11: Array<any> = [];

  datachart11: Array<any> = [];

  ctx11: any;

  ctx14: any;

  ctx20: any;

  CHART_COLORS3: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };

  constructor(private notifyService: NotificationService,

    private router: Router,

    private otherService: OtherService,

    private gurdService: GurdServiceService,

    private mapService: MapService,


  ) {

    Chart.register(...registerables);

    Chart.register(zoomPlugin);

  }

  ngOnInit(): void {

    this.getAppUsers_Login();

    this.getSiteReferrer();

    this.getVisit_BaseHour();

    this.getCountBaseDate();

    this.getCount_BaseSourceCity();

    this.getCount_BaseDestinationCity();

    this.getCount_BaseSource2Destination();

    this.getCount_BaseCountBaseHour();

    this.getBaseMobileGroup();

    this.getCount_BaseCountBaseDriver();

    this.getCount_BaseCountBasePassenger();

    this.getDashboard_Source();

    this.getDashboard_Destination();

  }

  getAppUsers_Login = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    }

    const resp = await axios.post(`TaxiLon_Dashboard_User`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }

    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }

    this.obj1 = resParse;

    this.label1 = [];

    this.datachart1 = [];

    this.obj1.forEach((element: any) => {

      this.label1.push(element.X);

      this.datachart1.push(element.Y);

    });

    const ctx = document.getElementById('myChart1') as any;

    if (this.ctx1) {

      this.ctx1.destroy();

    }

    this.ctx1 = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.label1,
        datasets: [
          {
            label: 'تعداد ورود',
            data: this.datachart1,
            fill: false,
            borderColor: "#FF3333",
            backgroundColor: "#e755ba",
            pointBackgroundColor: "#990000",
            pointBorderColor: "#990000",
            pointRadius: 4
          },
        ],

      },

      options: {
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      }
    });

  }

  getSiteReferrer = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`TaxiLon_Dashboard_Visit_BaseReferrer`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;


    }

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;
    }

    this.obj2 = resParse;

    this.label2 = [];

    this.datachart2 = [];

    this.obj2.forEach((element: any) => {

      this.label2.push(element.X);

      this.datachart2.push(element.Y);

    });

    const ctx = document.getElementById('myChart2') as any;

    if (this.ctx12) {

      this.ctx12.destroy();

    }
    this.ctx12 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label2,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart2,
            backgroundColor: Object.values(this.CHART_COLORS3),

            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });

  }

  getVisit_BaseHour = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`TaxiLon_Dashboard_Visit_BaseHour`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;


    }

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;
    }

    this.obj3 = resParse;

    this.label3 = [];

    this.datachart3 = [];

    this.obj3.forEach((element: any) => {

      this.label3.push(element.X);

      this.datachart3.push(element.Y);

    });

    const ctx = document.getElementById('myChart3') as any;

    if (this.ctx13) {

      this.ctx13.destroy();

    }
    this.ctx13 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label3,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart3,
            backgroundColor: Object.values(this.CHART_COLORS3),

            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });

  }

  getCountBaseDate = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    }

    const resp = await axios.post(`EmdadRo_Dashboard_CountBaseDate`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }

    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }

    this.obj4 = resParse;

    this.label4 = [];

    this.datachart4 = [];

    this.obj4.forEach((element: any) => {

      this.label4.push(element.X);

      this.datachart4.push(element.Y);

    });

    const ctx = document.getElementById('myChart4') as any;

    if (this.ctx4) {

      this.ctx4.destroy();

    }

    this.ctx4 = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.label4,
        datasets: [
          {
            label: 'تعداد خدمت',
            data: this.datachart4,
            fill: false,
            borderColor: "#FF3333",
            backgroundColor: "#e755ba",
            pointBackgroundColor: "#990000",
            pointBorderColor: "#990000",
            pointRadius: 4
          },
        ],

      },

      options: {
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      }
    });

  }

  getCount_BaseSourceCity = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`EmdadRo_Dashboard_CountBaseSourceCity`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;


    }

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;
    }

    this.obj5 = resParse;

    this.label5 = [];

    this.datachart5 = [];

    this.obj5.forEach((element: any) => {

      this.label5.push(element.X);

      this.datachart5.push(element.Y);

    });

    const ctx = document.getElementById('myChart5') as any;

    if (this.ctx15) {

      this.ctx15.destroy();

    }
    this.ctx15 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label5,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart5,
            backgroundColor: Object.values(this.CHART_COLORS3),

            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });

  }

  getCount_BaseDestinationCity = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`EmdadRo_Dashboard_CountBaseDestinationCity`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;


    }

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;
    }

    this.obj6 = resParse;

    this.label6 = [];

    this.datachart6 = [];

    this.obj6.forEach((element: any) => {

      this.label6.push(element.X);

      this.datachart6.push(element.Y);

    });

    const ctx = document.getElementById('myChart6') as any;

    if (this.ctx16) {

      this.ctx16.destroy();

    }
    this.ctx16 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label6,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart6,
            backgroundColor: Object.values(this.CHART_COLORS3),

            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });

  }

  getCount_BaseSource2Destination = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`EmdadRo_Dashboard_CountBaseSource2Destination`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;


    }

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;
    }

    this.obj7 = resParse;

    this.label7 = [];

    this.datachart7 = [];

    this.obj7.forEach((element: any) => {

      this.label7.push(element.X);

      this.datachart7.push(element.Y);

    });

    const ctx = document.getElementById('myChart7') as any;

    if (this.ctx17) {

      this.ctx17.destroy();

    }
    this.ctx17 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label7,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart7,
            backgroundColor: Object.values(this.CHART_COLORS3),

            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });

  }

  getCount_BaseCountBaseHour = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`EmdadRo_Dashboard_CountBaseHour`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;


    }

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;
    }

    this.obj8 = resParse;

    this.label8 = [];

    this.datachart8 = [];

    this.obj8.forEach((element: any) => {

      this.label8.push(element.X);

      this.datachart8.push(element.Y);

    });

    const ctx = document.getElementById('myChart8') as any;

    if (this.ctx18) {

      this.ctx18.destroy();

    }
    this.ctx18 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label8,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart8,
            backgroundColor: Object.values(this.CHART_COLORS3),

            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });

  }

  getBaseMobileGroup = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    let res = JSON.parse(((await axios.post(`EmdadRo_Dashboard_CountBaseMobileGroup`, model)).data.toString()));

    let label: Array<any> = [];

    let datachart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      datachart.push(element.Y);

    });

    var canvas = document.getElementById("myChart11") as any;

    var ctx = canvas.getContext("2d");

    const data = {

      labels: label,

      datasets: [

        {
          data: datachart,

          backgroundColor: Object.values(this.CHART_COLORS3),

        },

      ],

    } as any;

    if (this.ctx11) this.ctx11.destroy();

    this.ctx11 = new Chart(ctx, {

      type: 'pie',

      data: data,

      options: {

        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },

        plugins: {

          legend: {

            position: 'top',

            labels: {

              color: "black",

            }

          },

          title: {

            display: false,

          },

        },

      },

    });

    var chartEl = document.getElementById("myChart11") as any;

    chartEl.height = 200;

  }

  getCount_BaseCountBaseDriver = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`EmdadRo_Dashboard_CountBaseDriver`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;


    }

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;
    }

    this.obj9 = resParse;

    this.label9 = [];

    this.datachart9 = [];

    this.obj9.forEach((element: any) => {

      this.label9.push(element.X);

      this.datachart9.push(element.Y);

    });

    const ctx = document.getElementById('myChart9') as any;

    if (this.ctx19) {

      this.ctx19.destroy();

    }
    this.ctx19 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label9,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart9,
            backgroundColor: Object.values(this.CHART_COLORS3),

            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });

  }

  getCount_BaseCountBasePassenger = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`EmdadRo_Dashboard_CountBaseSystemUser`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;


    }

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;
    }

    this.obj10 = resParse;

    this.label10 = [];

    this.datachart10 = [];

    this.obj10.forEach((element: any) => {

      this.label10.push(element.X);

      this.datachart10.push(element.Y);

    });

    const ctx = document.getElementById('myChart10') as any;

    if (this.ctx110) {

      this.ctx110.destroy();

    }
    this.ctx110 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label10,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart10,
            backgroundColor: Object.values(this.CHART_COLORS3),

            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });

  }

  async getDashboard_Source() {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    let res = JSON.parse(((await axios.post(`EmdadRo_Dashboard_SourcePositation`, model)).data.toString()));

    setTimeout(() => {

      if (this.ctx14) this.ctx14.setTarget(null);

      var layers2 = [

        new Tile({

          source: new OSM()

        })

      ];

      this.ctx14 = new Map({

        target: "map1",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: layers2

      });

      this.clustersLayer(res, model);

    }, 500);

  }

  async clustersLayer(data: any, model: any) {

    setTimeout(() => {

      this.ctx14.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(
          this.ctx14.getEventPixel(e.originalEvent),
          this.ctx14
        );

        // if (el.featureLayer && el.featureLayer.feature.values_.features.length == 1) this.showDetail(el.featureLayer.feature.values_.features[0].values_.data.strMobile, model)

        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.ctx14.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;


    let addFeatures = (nb: any) => {
      var ext = this.ctx14.getView().calculateExtent(this.ctx14.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].fLon,
            data[i].fLat])

          ),
          id_: data[i].strUnitId,
          data: {
            strMobile: data[i].strMobile,
            strMobileDomain_strComment: data[i].strMobileDomain_strComment,
            strPassenger_FullName: data[i].strPassenger_FullName,
          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.ctx14.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });

    this.ctx14.addInteraction(selectCluster);


  }

  async getDashboard_Destination() {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    let res = JSON.parse(((await axios.post(`EmdadRo_Dashboard_DestinationPositation`, model)).data.toString()));

    setTimeout(() => {

      if (this.ctx20) this.ctx20.setTarget(null);

      var layers2 = [

        new Tile({

          source: new OSM()

        })

      ];

      this.ctx20 = new Map({

        target: "map2",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: layers2

      });

      this.clustersLayer_2(res, model);

    }, 500);

  }

  async clustersLayer_2(data: any, model: any) {

    setTimeout(() => {

      this.ctx20.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(
          this.ctx20.getEventPixel(e.originalEvent),
          this.ctx20
        );

        // if (el.featureLayer && el.featureLayer.feature.values_.features.length == 1) this.showDetail(el.featureLayer.feature.values_.features[0].values_.data.strMobile, model)

        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.ctx20.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;


    let addFeatures = (nb: any) => {
      var ext = this.ctx20.getView().calculateExtent(this.ctx20.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].fLon,
            data[i].fLat])

          ),
          id_: data[i].strUnitId,
          data: {
            strMobile: data[i].strMobile,
            strMobileDomain_strComment: data[i].strMobileDomain_strComment,
            strPassenger_FullName: data[i].strPassenger_FullName,
          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.ctx20.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });

    this.ctx20.addInteraction(selectCluster);


  }

}
